import {pinFilledSvg as Icon__small__pinFilledSvg} from '../Icon__small/Icon__small--pinFilled.js';

export var pinFilled = {
  name: 'pinFilled',
  category: 'icon',
  colorable: true,
  svg: Icon__small__pinFilledSvg,
};
